module.exports = __webpack_public_path__ + "img/phone-notif.1c33ec34.webp";